export const checkRequiredValidationWithMinMax = (
  text,
  fieldName,
  min,
  max,
  required = true
) => {
  let error = "";
  if (required === true) {
    if (text === "" || text === 0) {
      return (error = fieldName + "_is_required");
    }
  }
  if (text.length < min) {
    error = fieldName + "_must_be_minimum_" + min + "_characters";
  }
  if (text.length > max) {
    error = fieldName + "_must_be_maximum " + max + "_characters";
  }
  return error;
};
export const checkValidationWithMinMax = (
  text,

  min,
  max,

) => {
  let error = "";
 
  if (text.length < min) {
    error =  "lbl_must_be_minimum_" + min + "_characters";
  }
  if (text.length > max) {
    error = "lbl_must_be_maximum " + max + "_characters";
  }
  return error;
};

export const checkEmailTypeValidation = (email, required = true) => {
  let error = "";

  const pattern =
    /^[a-zA-Z0-9_]+(\.[a-zA-Z0-9_]+)*@[a-z0-9]+([a-z0-9]+)*(\.[a-z0-9]+([a-z0-9]+)*)*\.[a-z]{2,4}$/;
  if (pattern.test(email)) {
    return "";
  } else {
    return error ="lbl_enter_valid_email";
  }
  return error;
};
export const checkTextValidationWithMinMax = (
  text,

  min,
  max,
  required = true
) => {
  let error = "";
 

  if (text.length < min) {
    error =  "lbl_must_be_minimum_" + min + "_characters";
  }
  if (text.length > max) {
    error = "lbl_must_be_maximum" + max + "_characters";
  }
  if(!/^[\p{L}\s]+$/u.test(text)){
    error = "lbl_must_contain_only_alphabets" ;
  }
  return error;
};
export const checkRequiredTextValidationWithMinMax = (
  text,
  fieldName,
  min,
  max,
  required = true
) => {
  let error = "";
  if (required === true) {
    if (text === "" || text === 0) {
      return (error = fieldName + "_is_required");
    }
  }

  if (text.length < min) {
    error = fieldName + "_must_be_minimum_" + min + "_characters";
  }
  if (text.length > max) {
    error = fieldName + "_must_be_maximum " + max + "_characters";
  }
  if(!/^[\p{L}\s]+$/u.test(text)){
    error = fieldName + "_must_contain_only_alphabets" ;
  }
  return error;
};

export const checkEmptyValidation = (field, fieldName) => {
  let error = "";
  if (field === "" || field === undefined || field.length === 0 || field === null ) {
    error = fieldName + "_is_required";
  }
  return error;
};

export const matchPassword = (newPassword, confirmPassword) => {
  let error = "";
  if (newPassword !== confirmPassword) {
    error = "lbl_compare_new_pass_and_confirm_pass";
  }
  return error;
};

export const checkEmptyValidationAgree = (field, fieldName) => {
  let error = "";
  if (field === "false" || field === "") {
    error = fieldName + "_is_required";
  }
  return error;
};

export const checkEmptyDateValidation = (field, fieldName) => {
  let error = "";
  if (field === "" || field === null) {
    error = fieldName + "_is_required";
  }
  return error;
};

export const isFutureDate=(dateStr,fieldName) =>{
  let error = "";
  if ( dateStr === null) {
    error = fieldName + "_is_required";
    return error;
  }
  const inputDate = new Date(dateStr);


  if(isNaN(inputDate.getTime())){
    error = "lbl_invalid_date_string";
    return error;
  }

 
  
  else return error


 


}

export const checkEmailValidation = (email,emailText, required = true) => {
  let error = "";
  if (required === true) {
    if (email === "") {
     return error = emailText + "_is_required";
    }
  }
  const pattern =
    /^[a-zA-Z0-9_]+(\.[a-zA-Z0-9_]+)*@[a-z0-9]+([a-z0-9]+)*(\.[a-z0-9]+([a-z0-9]+)*)*\.[a-z]{2,4}$/;
  if (pattern.test(email)) {
    return "";
  } else {
    return error = emailText + "_enter_valid_email";
  }
  return error;
};

export const checkMultipleChekboxSelectionWithMinMax = (
  array,
  min = 0,
  max = 10000000
) => {
  let ids = [];
  array.forEach((element, index) => {
    if (element === true) {
      ids.push(index);
    }
  });
  let response = {};
  response.error = "";
  response.data = ids;
  if (ids.length < min) {
    response.error = "Minimum " + min + " item selections is required";
  }

  if (ids.length > max) {
    response.error = "Maximum item selections is " + min;
  }
  return response;
};

export const checkDropdownValidation = (field, fieldName) => {
  let error = "";

  if (field === "") {
    error = "Please select " + fieldName;
  }
  return error;
};

export const checkMobileNumberValidation = (
  field,
  text,
  min,
  max,
  minNumber = false
) => {
  let error = "";

  if (field === "" || field === undefined || field === null) {
    return (error = `${text}_is_required`);
  }
  let field1 = parseInt(field);
  if (!Number.isInteger(field1)) {
    return (error = `${text}_must_be_a_number`);
  }
  if (field.length < min) {
    return (error = `${text}_should_be_minimum` + min + "_digit");
  }
  if (field.length > max) {
    return (error = `${text}__must_not_be_greater_than` + max + "_digit");
  }
  if (minNumber && field <= 0) {
    return (error = `${text}__must_be_greater_than 1`);
  }
  return error;
};

export const RandomNumber = (length) => {
  var result = "";
  var characters =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i <= length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const checkRequiredValidationWithOTPMinMax = (
  text,
  fieldName,
  max,
  required = true
) => {
  let error = "";

  if (required === true) {
    if (text === "" || text === 0) {
      return (error = fieldName + "_is_required");
    }
  }
  if (text.length !== max) {
    error = fieldName + "_must_be_6_character";
  }

  return error;
};

export const checkRequiredValidationWithMobile = (
  text,
  fieldName,
  max,
  required = true
) => {
  let error = "";

  if (required === true) {
    if (text === "" || text === 0) {
      return (error = fieldName + " is required");
    }
  }
  if (text.length !== max) {
    error = fieldName + " must be 10 (Ten) digits";
  }

  return error;
};


export  function isValidDateRange(fromDateStr, toDateStr) {
  const fromDate = new Date(fromDateStr);
  const toDate = new Date(toDateStr);

  // Check if either date is invalid
  if (isNaN(fromDate) || isNaN(toDate)) {
    console.error("Invalid date format");
    return false;
  }

  // Check if 'toDate' is before 'fromDate'
  return toDate >= fromDate;
}

export function isValidSelection(selectionList,fieldName) {
  let error =""
  if(selectionList?.length==0 || selectionList==""){
return error =fieldName + "_is_required"
  }
else if(! selectionList.some(item => 
    typeof item.value === 'string' && item.value.trim() !== ''
  )){
  return error="Minimum_one_is_required"
} 
return error
}